import React from 'react';
import { Button } from '@mui/material';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { useTheme } from '@mui/material/styles';
import { handleTakeAssessment } from '../../lib/helpers/helpers';

/** Order management screen has Re-Assess Your Diet; Diet Quality Goal card has Re-assess Your Diet */

/**
 * AssessDietButton component
 *
 * @param {Object} props - Component props
 * @param {Function} props.onClick - Function to execute when button is clicked
 * @param {Object} props.sx - Additional style props to apply to the button
 * @param {any} props.rest - Any additional props to pass to the Button component
 *
 * @returns {JSX.Element} The AssessDietButton component
 */

const AssessDietButton = ({ sx = {}, ...rest }) => {
  const theme = useTheme();

  return (
    <Button
      variant="contained"
      sx={{
        backgroundColor: theme.palette.admin.main,
        color: 'white',
        fontWeight: 700,
        border: '1px solid var(--color12, #1C124D)',
        background: 'var(--color12, #1C124D)',
        borderRadius: '8px',
        display: 'flex',
        padding: '6px 16px !important',
        lineHeight: '24px',
        letterSpacing: '0.4px',
        '&.MuiButton-root': {
          padding: '6px 16px',
        },
        ...sx,
      }}
      endIcon={<ArrowForwardIcon />}
      onClick={handleTakeAssessment}
      {...rest}
    >
      Assess My Diet
    </Button>
  );
};

export default AssessDietButton;
